
export const createPercentageSubtitle = (value, divider, ofTitle) => {
    const percentage = (value / divider * 100) || 0;
    return `${percentage.toFixed(2)}% of ${ofTitle}`;
}


export const findEventsCount = (arr, eventName) => {
    const events = arr.find((element) => element.eventName === eventName);
    return events ? events.count : 0;
}
